import * as React from "react";

import './SecondaryBar.pcss';
import {useEffect, useRef} from "react";

interface Props {
  title:string;
  subTitle?:string;
  buttonAction:()=>void;
  buttonLabel?:string;
  children?:any;
}

export function SecondaryBar(props:Props) {

  const h1Ref = useRef(null);
  useEffect(()=>{
    if(h1Ref && h1Ref.current) {
      // @ts-ignore
      h1Ref.current.focus();
    }
  });

  let buttonProps = {
    onClick:props.buttonAction
  }
  buttonProps['aria-label'] = props.buttonLabel ? props.buttonLabel : "Back to previous page";

  return (
    <div className={"secondary-bar"}>
      <div className={"lft"}>
        <div className={"lft-back"}><button {...buttonProps}><span className="material-symbols-outlined">arrow_back_ios</span></button></div>
        <div className={"lft-head"}>
              <h1 ref={h1Ref} tabIndex={0}>{props.title}</h1>
              {props.subTitle && <p>{props.subTitle}</p>}
        </div>
      </div>
      <div className={"rt"}>
        {props.children?props.children:null}
      </div>
    </div>
  );
}
